import React, { useState } from 'react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false); // Cerrar el menú en móvil después de hacer click
    }
  };

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-6xl mx-auto flex justify-between items-center py-3 px-4 md:px-8">
        {/* Logo */}
        <div className="flex items-center">
          <img src="/logo.png" alt="Logo YupiSoft" className="h-20 w-auto" />
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-6">
          <button onClick={() => handleClick('inicio')} className="text-gray-600 hover:text-[#03ADED] transition-colors font-medium">Inicio</button>
          <button onClick={() => handleClick('servicios')} className="text-gray-600 hover:text-[#03ADED] transition-colors font-medium">Productos</button>
          <button onClick={() => handleClick('precios')} className="text-gray-600 hover:text-[#03ADED] transition-colors font-medium">Precios</button>
          <button onClick={() => handleClick('contacto')} className="text-gray-600 hover:text-[#03ADED] transition-colors font-medium">Contacto</button>
          <a href="https://wa.me/51972843376" target="_blank" rel="noopener noreferrer" className="bg-[#03ADED] hover:bg-[#0288D1] text-white px-5 py-2 rounded-full font-semibold transition-all">
            Agendar cita
          </a>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center">
          <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600">
            <svg className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              {isOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isOpen && (
        <div className="md:hidden bg-white shadow-md rounded-b-lg">
          <div className="flex flex-col items-center space-y-4 py-4">
            <button onClick={() => handleClick('inicio')} className="text-gray-600 hover:text-[#03ADED] font-medium">Inicio</button>
            <button onClick={() => handleClick('servicios')} className="text-gray-600 hover:text-[#03ADED] font-medium">Productos</button>
            <button onClick={() => handleClick('precios')} className="text-gray-600 hover:text-[#03ADED] font-medium">Precios</button>
            <button onClick={() => handleClick('contacto')} className="text-gray-600 hover:text-[#03ADED] font-medium">Contacto</button>
            <a href="https://wa.me/51972843376" target="_blank" rel="noopener noreferrer" className="bg-[#03ADED] hover:bg-[#0288D1] text-white px-5 py-2 rounded-full font-semibold transition-all">
              Agendar cita
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
